import { takeLatest, put, call } from 'redux-saga/effects';
import {
  GET_ASSETS,
  GET_JURIDICAL_CERT,
  SET_ASSETS,
} from '../../state/assets/types';
import { CLEAR_ERRORS, FETCH_ERRORS } from '../error/types';
import { STATUS } from '../../config/constants/states';
import { getAssets, juridicCertificate } from '../../network/assets';

function* contractAssets(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const data = yield call(getAssets, payload.id);
    yield put({ type: SET_ASSETS, payload: data.data.payload });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e.response.status || 500,
      }
    });
  }
};

function* legalPersonCertificate(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(juridicCertificate, payload.id);
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e.response.status || 500,
      }
    });
  }
};

function* watchGetAssets() {
  yield takeLatest(GET_ASSETS, contractAssets);
};

function* watchGetJuridicalCert() {
  yield takeLatest(GET_JURIDICAL_CERT, legalPersonCertificate);
};

export default [
  watchGetAssets(),
  watchGetJuridicalCert(),
];